import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

export interface StrollersFilter {
    [key: string]: string | string[];
}

export interface ChartsLoadApiAction extends Action {
    readonly filter: StrollersFilter;
}

export const CHARTS_LOAD_API_REQUEST = "CHARTS_LOAD_API_REQUEST";

export interface ChartsLoadApiRequestAction extends ChartsLoadApiAction, APIRequestAction {
    readonly type: typeof CHARTS_LOAD_API_REQUEST;
}

export interface ChartsLoadApiNormalizedResponse extends NormalizedResponse {
    readonly result: {
        strollersByUserScore: number[];
        strollersByProfileCount: number[];
    };
}

export const CHARTS_LOAD_API_SUCCESS = "CHARTS_LOAD_API_SUCCESS";

export interface ChartsLoadApiSuccessAction
    extends ChartsLoadApiAction, APISuccessAction<ChartsLoadApiNormalizedResponse> {
    readonly type: typeof CHARTS_LOAD_API_SUCCESS;
}

export const CHARTS_LOAD_API_FAILURE = "CHARTS_LOAD_API_FAILURE";

export interface ChartsLoadApiFailureAction extends ChartsLoadApiAction, APIFailureAction {
    readonly type: typeof CHARTS_LOAD_API_FAILURE;
}

export const chartsLoadApi = {
    request: (filter: StrollersFilter): ChartsLoadApiRequestAction => ({
        type: CHARTS_LOAD_API_REQUEST,
        filter,
    }),
    success: (
        filter: StrollersFilter,
        response: ChartsLoadApiNormalizedResponse,
    ): ChartsLoadApiSuccessAction => ({
        type: CHARTS_LOAD_API_SUCCESS,
        filter,
        response,
    }),
    failure: (filter: StrollersFilter, error: any): ChartsLoadApiFailureAction => ({
        type: CHARTS_LOAD_API_FAILURE,
        filter,
        error,
    }),
};

export const CHARTS_LOAD = "CHARTS_LOAD";

export interface ChartsLoadAction extends ChartsLoadApiAction {
    readonly type: typeof CHARTS_LOAD;
}

export const chartsLoad = (filter: StrollersFilter = {}): ChartsLoadAction => ({
    type: CHARTS_LOAD,
    filter,
});
